import { InfoOutlined } from "@mui/icons-material";
import { Box, Rating } from "@mui/material";

type Props = {
  rating: number;
  showInfoIcon?: boolean;
};

export const StarRating = ({ rating, showInfoIcon }: Props) => (
  <Box display="flex" alignItems="center" gap={1} height="100%">
    <Rating
      readOnly
      value={rating}
      precision={0.25}
      size="small"
      sx={{ color: "primary.main" }}
    />
    {showInfoIcon && (
      <InfoOutlined
        sx={{
          width: 17,
          height: 17,
          color: ({ palette }) => palette.grey[500],
        }}
      />
    )}
  </Box>
);
